import React from 'react'
import PropTypes from 'prop-types'
import { graphql } from 'gatsby'
import Helmet from 'react-helmet'
import Layout from '../components/Layout';
import Quote from "../components/Quote";
import CTA from "../components/CTA";
import Brands from "../components/base/Brands";
import Testimonial from "../components/base/Testimonial";

export const WhatSSDLCTemplate = ( {
seo,
content1,
content2,
content3,
content4,
content6,
content7,
content9,
content10,
content11,
quote,
}) => (
  <div className="custompages">
    			<Helmet titleTemplate={seo.titlePostfix} htmlAttributes={{ lang: 'en_US' }}>
				<title>What Is SSDLC</title>
				<meta
					name="description"
					content="This needs to be text"
				/>
			</Helmet>
    <div
        className="full-width-image"
        style={{
          backgroundImage: `url('/img/CypressHeaderImage3.webp')`,
          backgroundPosition: 'center center',
          backgroundSize: 'cover',
          height: '450px',
          marginTop: '6rem',
        }}
      >
        <div className="herotext-content-wrapper">
						<h1 className="herotext-title">What Is SSDLC</h1>
        </div>
      </div>
    <CTA />
    <div
      className="section sdlc-content-section"
      style={{
        backgroundColor: content1.sectionbg,
        overflow: "hidden",
        position: "relative",
      }}
    >
      <div className="container sdlc-content-container">
        <div className="columns content-image-wrapper" style={{ maxWidth: "100%" }}>
          <div className="column is-11 content-no-image">
            {content1.title && (
              <h1 className="has-text-weight-bold is-size-4-mobile is-size-3-tablet is-size-2-widescreen item-title">
                {content1.title}
              </h1>
            )}
            {content1.description1 && <p className="item-description">{content1.description1}</p>}
            {content1.description2 && <p className="item-description">{content1.description2}</p>}
            {content1.description3 && <p className="item-description">{content1.description3}</p>}
            {content1.description4 && <p className="item-description">{content1.description4}</p>}

            {content1.list?.length > 0 && (
              <ul className="list-items">
                {content1.list.map((orderItem, idx) => (
                  <li className="list-item" key={idx}>{orderItem.description}</li>
                ))}
              </ul>
            )}

            {content1.description5 && <p className="item-description">{content1.description5}</p>}
            {content1.description6 && <p className="item-description">{content1.description6}</p>}
            {content1.description7 && <p className="item-description">{content1.description7}</p>}

            {content1.buttonlink && content1.buttontxt && (
              <div className="btn-wrapper">
                <a href={content1.buttonlink}>
                  <button className="btn-golden">{content1.buttontxt}</button>
                </a>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
    <div
      className="section sdlc-content-section"
      style={{
        backgroundColor: content2.sectionbg,
        overflow: "hidden",
        position: "relative",
      }}
    >
      <div className="container sdlc-content-container">
        <div className="columns content-image-wrapper" style={{ maxWidth: "100%" }}>
          <div className="column is-11 content-no-image">
            {content2.title && (
              <h1 className="has-text-weight-bold is-size-4-mobile is-size-3-tablet is-size-2-widescreen item-title">
                {content2.title}
              </h1>
            )}

            {content2.description1 && <p className="item-description">{content2.description1}</p>}
            {content2.description2 && <p className="item-description">{content2.description2}</p>}

            {content2.subtitle && <p className="item-subtitle">{content2.subtitle}</p>}

            {content2.description3 && <p className="item-description">{content2.description3}</p>}
            {content2.description4 && <p className="item-description">{content2.description4}</p>}

            {content2.subtitle2 && <p className="item-subtitle">{content2.subtitle2}</p>}

            {content2.description5 && <p className="item-description">{content2.description5}</p>}

            {content2.subtitle3 && <p className="item-subtitle">{content2.subtitle3}</p>}

            {content2.description6 && <p className="item-description">{content2.description6}</p>}
            {content2.description7 && <p className="item-description">{content2.description7}</p>}

            {content2.buttonlink && content2.buttontxt && (
              <div className="btn-wrapper">
                <a href={content2.buttonlink}>
                  <button className="btn-golden">{content2.buttontxt}</button>
                </a>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
    <div
      className="section sdlc-content-section"
      style={{
        backgroundColor: content3.sectionbg,
        overflow: "hidden",
        position: "relative",
      }}
    >
      <div className="container sdlc-content-container">
        <div className="columns content-image-wrapper" style={{ maxWidth: "100%" }}>
          <div className="column is-11 content-no-image">
            {content3.title && (
              <h1 className="has-text-weight-bold is-size-4-mobile is-size-3-tablet is-size-2-widescreen item-title">
                {content3.title}
              </h1>
            )}

            {content3.description1 && <p className="item-description">{content3.description1}</p>}
            {content3.description2 && <p className="item-description">{content3.description2}</p>}
            {content3.description3 && <p className="item-description">{content3.description3}</p>}

            {content3.buttonlink && content3.buttontxt && (
              <div className="btn-wrapper">
                <a href={content3.buttonlink}>
                  <button className="btn-golden">{content3.buttontxt}</button>
                </a>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
    <div
      className="section sdlc-content-section"
      style={{
        backgroundColor: content4.sectionbg,
        overflow: "hidden",
        position: "relative",
      }}
    >
      <div className="container sdlc-content-container">
        <div className="columns content-image-wrapper" style={{ maxWidth: "100%" }}>
          <div className="column is-11 content-no-image">
            {content4.title && (
              <h1 className="has-text-weight-bold is-size-4-mobile is-size-3-tablet is-size-2-widescreen item-title">
                {content4.title}
              </h1>
            )}

            {content4.description1 && <p className="item-description">{content4.description1}</p>}
            {content4.description2 && <p className="item-description">{content4.description2}</p>}
            {content4.description3 && <p className="item-description">{content4.description3}</p>}
            {content4.description4 && <p className="item-description">{content4.description4}</p>}

            {content4.subtitle && <p className="item-subtitle">{content4.subtitle}</p>}

            {content4.description5 && <p className="item-description">{content4.description5}</p>}
            {content4.description6 && <p className="item-description">{content4.description6}</p>}
            {content4.description7 && <p className="item-description">{content4.description7}</p>}
            {content4.description8 && <p className="item-description">{content4.description8}</p>}
            {content4.description9 && <p className="item-description">{content4.description9}</p>}

            {content4.subtitle2 && <p className="item-subtitle">{content4.subtitle2}</p>}

            {content4.description10 && <p className="item-description">{content4.description10}</p>}
            {content4.description11 && <p className="item-description">{content4.description11}</p>}
            {content4.description12 && <p className="item-description">{content4.description12}</p>}
            {content4.description13 && <p className="item-description">{content4.description13}</p>}
            {content4.description14 && <p className="item-description">{content4.description14}</p>}

            {content4.buttonlink && content4.buttontxt && (
              <div className="btn-wrapper">
                <a href={content4.buttonlink}>
                  <button className="btn-golden">{content4.buttontxt}</button>
                </a>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
    <div
      className="section sdlc-content-section"
      style={{
        backgroundColor: content6.sectionbg,
        overflow: "hidden",
        position: "relative",
      }}
    >
      <div className="container sdlc-content-container">
        <div className="columns content-image-wrapper" style={{ maxWidth: "100%" }}>
          <div className="column is-11 content-no-image">
            {content6.title && (
              <h1 className="has-text-weight-bold is-size-4-mobile is-size-3-tablet is-size-2-widescreen item-title">
                {content6.title}
              </h1>
            )}

            {content6.description1 && <p className="item-description">{content6.description1}</p>}
            {content6.description2 && <p className="item-description">{content6.description2}</p>}

            {content6.subtitle && <p className="item-subtitle">{content6.subtitle}</p>}

            {content6.description3 && <p className="item-description">{content6.description3}</p>}

            {content6.buttonlink && content6.buttontxt && (
              <div className="btn-wrapper">
                <a href={content6.buttonlink}>
                  <button className="btn-golden">{content6.buttontxt}</button>
                </a>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
    <div
      className="section sdlc-content-section"
      style={{
        backgroundColor: content7.sectionbg,
        overflow: "hidden",
        position: "relative",
      }}
    >
      <div className="container sdlc-content-container">
        <div className="columns content-image-wrapper" style={{ maxWidth: "100%" }}>
          <div className="column is-11 content-no-image">
            {content7.title && (
              <h1 className="has-text-weight-bold is-size-4-mobile is-size-3-tablet is-size-2-widescreen item-title">
                {content7.title}
              </h1>
            )}

            {content7.description1 && <p className="item-description">{content7.description1}</p>}
            {content7.description2 && <p className="item-description">{content7.description2}</p>}
            {content7.description3 && <p className="item-description">{content7.description3}</p>}
            {content7.description4 && <p className="item-description">{content7.description4}</p>}
            {content7.description5 && <p className="item-description">{content7.description5}</p>}
            {content7.description6 && <p className="item-description">{content7.description6}</p>}
            {content7.description7 && <p className="item-description">{content7.description7}</p>}

            {content7.buttonlink && content7.buttontxt && (
              <div className="btn-wrapper">
                <a href={content7.buttonlink}>
                  <button className="btn-golden">{content7.buttontxt}</button>
                </a>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
    <div
      className="section sdlc-content-section"
      style={{
        backgroundColor: content9.sectionbg,
        overflow: "hidden",
        position: "relative",
      }}
    >
      <div className="container sdlc-content-container">
        <div className="columns content-image-wrapper" style={{ maxWidth: "100%" }}>
          <div className="column is-11 content-no-image">
            {content9.title && (
              <h1 className="has-text-weight-bold is-size-4-mobile is-size-3-tablet is-size-2-widescreen item-title">
                {content9.title}
              </h1>
            )}

            {content9.description1 && <p className="item-description">{content9.description1}</p>}
            {content9.description2 && <p className="item-description">{content9.description2}</p>}
            {content9.description3 && <p className="item-description">{content9.description3}</p>}
            {content9.description4 && <p className="item-description">{content9.description4}</p>}
            {content9.description5 && <p className="item-description">{content9.description5}</p>}
            {content9.description6 && <p className="item-description">{content9.description6}</p>}

            {content9.subtitle && <h2 className="item-subtitle">{content9.subtitle}</h2>}

            {content9.description7 && <p className="item-description">{content9.description7}</p>}
            {content9.description8 && <p className="item-description">{content9.description8}</p>}
            {content9.description9 && <p className="item-description">{content9.description9}</p>}
            {content9.description10 && <p className="item-description">{content9.description10}</p>}
            {content9.description11 && <p className="item-description">{content9.description11}</p>}
            {content9.description12 && <p className="item-description">{content9.description12}</p>}
            {content9.description13 && <p className="item-description">{content9.description13}</p>}
            {content9.description14 && <p className="item-description">{content9.description14}</p>}
            {content9.description15 && <p className="item-description">{content9.description15}</p>}

            {content9.subtitle2 && <h2 className="item-subtitle">{content9.subtitle2}</h2>}

            {content9.description16 && <p className="item-description">{content9.description16}</p>}
            {content9.description17 && <p className="item-description">{content9.description17}</p>}
            {content9.description18 && <p className="item-description">{content9.description18}</p>}
            {content9.description19 && <p className="item-description">{content9.description19}</p>}
            {content9.description20 && <p className="item-description">{content9.description20}</p>}

            {content9.list?.length > 0 && (
              <ul className="list-items">
                {content9.list.map((orderItem, idx) => (
                  <li className="list-item" key={idx}>{orderItem.description}</li>
                ))}
              </ul>
            )}

            {content9.subtitle3 && <h2 className="item-subtitle">{content9.subtitle3}</h2>}

            {content9.description21 && <p className="item-description">{content9.description21}</p>}
            {content9.description22 && <p className="item-description">{content9.description22}</p>}
            {content9.description23 && <p className="item-description">{content9.description23}</p>}
            {content9.description24 && <p className="item-description">{content9.description24}</p>}

            {content9.subtitle4 && <h2 className="item-subtitle">{content9.subtitle4}</h2>}

            {content9.description25 && <p className="item-description">{content9.description25}</p>}
            {content9.description26 && <p className="item-description">{content9.description26}</p>}
            {content9.description27 && <p className="item-description">{content9.description27}</p>}

            {content9.subtitle5 && <h2 className="item-subtitle">{content9.subtitle5}</h2>}

            {content9.description28 && <p className="item-description">{content9.description28}</p>}
            {content9.description29 && <p className="item-description">{content9.description29}</p>}

            {content9.buttonlink && content9.buttontxt && (
              <div className="btn-wrapper">
                <a href={content9.buttonlink}>
                  <button className="btn-golden">{content9.buttontxt}</button>
                </a>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
    <div
      className="section sdlc-content-section"
      style={{
        backgroundColor: content10.sectionbg,
        overflow: "hidden",
        position: "relative",
      }}
    >
      <div className="container sdlc-content-container">
        <div className="columns content-image-wrapper" style={{ maxWidth: "100%" }}>
          <div className="column is-11 content-no-image">
            {content10.title && (
              <h1 className="has-text-weight-bold is-size-4-mobile is-size-3-tablet is-size-2-widescreen item-title">
                {content10.title}
              </h1>
            )}

            {content10.description1 && <p className="item-description">{content10.description1}</p>}
            {content10.description2 && <p className="item-description">{content10.description2}</p>}

            {content10.subtitle && <h2 className="item-subtitle">{content10.subtitle}</h2>}

            {content10.description3 && <p className="item-description">{content10.description3}</p>}
            {content10.description4 && <p className="item-description">{content10.description4}</p>}
            {content10.description5 && <p className="item-description">{content10.description5}</p>}
            {content10.description6 && <p className="item-description">{content10.description6}</p>}

            {content10.subtitle2 && <h2 className="item-subtitle">{content10.subtitle2}</h2>}

            {content10.description7 && <p className="item-description">{content10.description7}</p>}
            {content10.description8 && <p className="item-description">{content10.description8}</p>}

            {content10.subtitle3 && <h2 className="item-subtitle">{content10.subtitle3}</h2>}

            {content10.description9 && <p className="item-description">{content10.description9}</p>}
            {content10.description10 && <p className="item-description">{content10.description10}</p>}
            {content10.description11 && <p className="item-description">{content10.description11}</p>}
            {content10.description12 && <p className="item-description">{content10.description12}</p>}

            {content10.buttonlink && content10.buttontxt && (
              <div className="btn-wrapper">
                <a href={content10.buttonlink}>
                  <button className="btn-golden">{content10.buttontxt}</button>
                </a>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
    <div
      className="section sdlc-content-section"
      style={{
        backgroundColor: content11.sectionbg,
        overflow: "hidden",
        position: "relative",
      }}
    >
      <div className="container sdlc-content-container">
        <div className="columns content-image-wrapper" style={{ maxWidth: "100%" }}>
          <div className="column is-11 content-no-image">
            {content11.title && (
              <h1 className="has-text-weight-bold is-size-4-mobile is-size-3-tablet is-size-2-widescreen item-title">
                {content11.title}
              </h1>
            )}

            {content11.description1 && <p className="item-description">{content11.description1}</p>}
            {content11.description2 && <p className="item-description">{content11.description2}</p>}
            {content11.description3 && <p className="item-description">{content11.description3}</p>}

            {content11.list?.length > 0 && (
              <ul className="list-items">
                {content11.list.map((orderItem, idx) => (
                  <li className="list-item" key={idx}>{orderItem.description}</li>
                ))}
              </ul>
            )}

            {content11.subtitle && <h2 className="item-subtitle">{content11.subtitle}</h2>}

            {content11.description4 && <p className="item-description">{content11.description4}</p>}
            {content11.description5 && <p className="item-description">{content11.description5}</p>}
            {content11.description6 && <p className="item-description">{content11.description6}</p>}
            {content11.description7 && <p className="item-description">{content11.description7}</p>}

            {content11.subtitle2 && <h2 className="item-subtitle">{content11.subtitle2}</h2>}

            {content11.description8 && <p className="item-description">{content11.description8}</p>}
            {content11.description9 && <p className="item-description">{content11.description9}</p>}
            {content11.description10 && <p className="item-description">{content11.description10}</p>}
            {content11.description11 && <p className="item-description">{content11.description11}</p>}

            {content11.subtitle3 && <h2 className="item-subtitle">{content11.subtitle3}</h2>}

            {content11.description12 && <p className="item-description">{content11.description12}</p>}
            {content11.description13 && <p className="item-description">{content11.description13}</p>}
            {content11.description14 && <p className="item-description">{content11.description14}</p>}

            {content11.subtitle4 && <h2 className="item-subtitle">{content11.subtitle4}</h2>}

            {content11.description15 && <p className="item-description">{content11.description15}</p>}
            {content11.description16 && <p className="item-description">{content11.description16}</p>}
            {content11.description17 && <p className="item-description">{content11.description17}</p>}
            {content11.description18 && <p className="item-description">{content11.description18}</p>}
            {content11.description19 && <p className="item-description">{content11.description19}</p>}
            {content11.description20 && <p className="item-description">{content11.description20}</p>}

            {content11.buttonlink && content11.buttontxt && (
              <div className="btn-wrapper">
                <a href={content11.buttonlink}>
                  <button className="btn-golden">{content11.buttontxt}</button>
                </a>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
    <Quote data={quote} />
    <Brands />
    <Testimonial />
    <div
        className="full-width-image margin-top-0 box-shadow"
        style={{
          backgroundImage: `url(/img/Cypress-Header-NetworkNodes.webp)`,
          backgroundPosition: `center center`,
          backgroundSize: 'cover',
          backgroundAttachment: `fixed`,
          height: `850px`,
        }}
      >
        <div className="container">
          <div className="columns is-vcentered" style={{ maxWidth: '100%', }}>
            <div className="column is-5">
                <img
                className="cta-image"
                  src="/img/LevelUpGraphic.png"
                  alt="Side Image"
                />
            </div>
            <div className="column is-7 cta-description-section">
              <a href="/contact">
                <h1
                  className="has-text-weight-bold cta-text">
                  The consultation is free.<br />
                  The peace of mind, <span style={{ color: "#52C5D0" }}>liberating</span>
                </h1>
                <div className="content-wrapper">
                  <p> Find out more about our EASy Managed Service. Take your first step toward proactive security for all your software to protect your business and for your peace of mind.</p>
                  <button className="btn-golden">Protect Your Business</button>
                  <p>Secure Your Software. Contact us for a free Consultation today</p>
                </div>
              </a>
            </div>
          </div>
        </div>
        <div
          style={{
            display: 'flex',
            height: '150px',
            lineHeight: '1',
            justifyContent: 'space-around',
            alignItems: 'left',
            flexDirection: 'column',
          }}
        >
        </div>
      </div>
  </div>
)

WhatSSDLCTemplate.propTypes = {
  seo: PropTypes.object,
  content1: PropTypes.object,
  content2: PropTypes.object,
  content3: PropTypes.object,
  content4: PropTypes.object,
  content6: PropTypes.object,
  content7: PropTypes.object,
  content9: PropTypes.object,
  content10: PropTypes.object,
  content11: PropTypes.object,
  quote: PropTypes.object,
}

const WhatSSDLC = ({ data }) => {
  const { frontmatter } = data.markdownRemark

  return (
    <Layout>
      <WhatSSDLCTemplate
        seo={frontmatter.seo}
        content1={frontmatter.introduction}
        content2={frontmatter.securitytrainingphase}
        content3={frontmatter.owasp}
        content4={frontmatter.requirementphase}
        content6={frontmatter.riskprofile}
        content7={frontmatter.planningdesignphase}
        content9={frontmatter.developmentphase}
        content10={frontmatter.verificationphase}
        content11={frontmatter.releasephase}
        quote={frontmatter.quotesection}
      />
    </Layout>
  )
}

WhatSSDLC.propTypes = {
  data: PropTypes.shape({
    markdownRemark: PropTypes.shape({
      frontmatter: PropTypes.object,
    }),
  }),
}

export default WhatSSDLC

export const pageQuery = graphql`
  query WhatSSDLCTemplate {
    markdownRemark(frontmatter: { templateKey: { eq: "what-is-ssdlc" } }) {
      frontmatter {
        seo {
          title
          description
        }
        introduction {
        sectionbg
        title
        description1
        description2
        description3
        description4
        list {
          description
        }
        description5
        description6
        description7
        }
        securitytrainingphase {
        sectionbg
        title
        description1
        description2
        subtitle
        description3
        description4
        subtitle2
        description5
        subtitle3
        description6
        description7
        }
        owasp {
        sectionbg
        title
        description1
        description2
        description3
        buttontxt
        buttonlink
        }
        requirementphase {
        sectionbg
        title
        description1
        description2
        description3
        subtitle
        description4
        description5
        description6
        description7
        subtitle2
        description8
        description9
        description10
        description11
        description12
        description13
        description14
        buttontxt
        buttonlink
        }
        riskprofile {
        sectionbg
        title
        description1
        description2
        subtitle
        description3
        }
        planningdesignphase {
        sectionbg
        title
        description1
        description2
        description3
        description4
        description5
        description6
        description7
        buttontxt
        buttonlink
        }
        developmentphase {
        sectionbg
        title
        description1
        description2
        description3
        description4
        description5
        description6
        subtitle
        description7
        description8
        description9
        description10
        description11
        description12
        description13
        description14
        description15
        subtitle2
        description16
        description17
        description18
        description19
        description20
        list {
          description
        }
        subtitle3
        description21
        description22
        description23
        description24
        subtitle4
        description25
        description26
        description27
        subtitle5
        description28
        description29
        buttontxt
        buttonlink
        }
        verificationphase {
        sectionbg
        title
        description1
        description2
        subtitle
        description3
        description4
        description5
        description6
        subtitle2
        description7
        description8
        subtitle3
        description9
        description10
        description11
        }
        releasephase {
        sectionbg
        title
        description1
        description2
        description3
        list {
          description
        }
        subtitle
        description4
        description5
        description6
        description7
        subtitle2
        description8
        description9
        description10
        description11
        subtitle3
        description12
        description13
        description14
        subtitle4
        description15
        description16
        description17
        description18
        description19
        buttontxt
        buttonlink
        }
        quotesection {
          title
          quote
          author
          image {
            childImageSharp {
              fluid(maxWidth: 400, quality: 100) {
              ...GatsbyImageSharpFluid
              }
            }
          }
          buttontxt
          buttonlink
        }
      }
    }
  }
`
